/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetHistoryPeriodsResponse {
    getFixupPrototypeFunction() { return BudgetHistoryPeriodsResponse.fixupPrototype; }

    static newInstance(model: Partial<BudgetHistoryPeriodsResponse>): BudgetHistoryPeriodsResponse {
        let obj = Object.assign(new BudgetHistoryPeriodsResponse(), model);
        BudgetHistoryPeriodsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetHistoryPeriodsResponse>): BudgetHistoryPeriodsResponse {
        if (!model) return null;
        return BudgetHistoryPeriodsResponse.newInstance(<BudgetHistoryPeriodsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetHistoryPeriodsResponse) {
        if (!obj) return;

        models.BudgetHistoryPeriodsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetHistoryPeriodsResponse): boolean {
        Object.setPrototypeOf(obj, BudgetHistoryPeriodsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.periods) {
            for (let val of this.periods) {
                models.BudgetHistoryPeriodModel.fixupPrototype(val);
            }
        }
    }

    /**
     * closed periods available for the requested frequency, newest first
     */
    periods: Array<models.BudgetHistoryPeriodModel>;

}
